// Fichier volontairement sans dépendance : utilisé par useSeasonStore (lui-même importé
// par config.ts) pour éviter tout cycle config.ts -> useSeasonStore -> dartsHubApi -> config.ts.
const env = import.meta.env.VITE_ENV;
const PORT_BACK_DARTSHUB: string = import.meta.env.VITE_PORT_BACK_DARTSHUB;

export const dartshubBaseUrl =
  env === 'dev'
    ? `http://localhost:${PORT_BACK_DARTSHUB}`
    : 'https://api.dartshub.fr';
